import { PrimeNGConfig } from 'primeng/api'
import { Component } from '@angular/core'

import { TEXT_FILTER_MATCH_MODES } from '@shared/components/tables/main-table/filter-match-mode.util'
import { LoaderService } from '@data/services/page/loader.service'

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'pulpi-v4-panel'
  constructor(
    private config: PrimeNGConfig,
    public loaderService: LoaderService,
  ) {
    this.config.setTranslation({
      startsWith: 'Empieza con',
      contains: 'Contiene',
      notContains: 'No contiene',
      endsWith: 'Acaba en',
      equals: 'Igual',
      notEquals: 'No igual',
      noFilter: 'Sin filtro',
      lt: 'Menor que',
      matchAll: 'Coincide con todos',
      matchAny: 'Coincide con cualquiera',
      dateIs: 'La fecha es',
      dateIsNot: 'La fecha no es',
      dateAfter: 'La fecha es despues de',
      dateBefore: 'La fecha es antes de',
      addRule: 'Agregar regla',
      clear: 'Limpiar',
      apply: 'Aplicar',
      gt: 'Mayor que',
      gte: 'Mayor o igual que',
      lte: 'Menor o igual que',
      //* Los calendarios también: sin esto decían «September 2026» en un panel en español.
      dayNames: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'],
      dayNamesShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
      dayNamesMin: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
      monthNames: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
      monthNamesShort: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
      today: 'Hoy',
      weekHeader: 'Sem',
      firstDayOfWeek: 1,
    })
    //* F-008: «Contiene» primero en el menú de los filtros de texto, que es también el modo con el que
    //* arrancan (ver defaultFilterMatchMode).
    this.config.filterMatchModeOptions.text = TEXT_FILTER_MATCH_MODES
  }
}
